import { InsightsCardsConsumption } from "../insights-cards-consumption/insights-cards-consumption";
import { AlertTriangle, BarChart2 } from "lucide-react";
import { useActionsTrack } from "@/_old/features/analytics";
import { useNavigate } from "react-router-dom";
import { useInsightsConsumption } from "./insights-consumption.hooks";
import { useTranslation } from "react-i18next";
import { InsightsCardsConsumptionSkeleton } from "../insights-cards-consumption/insights-cards-consumption-skeleton";
import { ConsumptionTrendEnum } from "./insights-consumption.types";
import { InsightsConsumptionTimeline } from "./insights-consumption-timeline";
import { ROUTES } from "@/_old/constants/routes";

export function InsightsConsumption({
  companyId,
  startDate,
  endDate,
  carousel = false,
}: {
  companyId: number;
  startDate: string;
  endDate: string;
  carousel?: boolean;
}) {
  const { onActionClick } = useActionsTrack();

  const navigate = useNavigate();

  const [translate] = useTranslation(["dashboard-charts"]);

  const { data, isLoading, type } = useInsightsConsumption({
    companyId,
    startDate,
    endDate,
  });

  const status = data?.status;

  if (isLoading || !data) {
    return <InsightsCardsConsumptionSkeleton carousel={carousel} />;
  }

  return (
    <InsightsCardsConsumption
      carousel={carousel}
      tag={translate("dashboard-consumption-" + status)}
      hasSubtitleDefaultColor={true}
      description={translate(
        "dashboard-consumption-" + status + "-description",
      )}
      buttonText={translate("dashboard-consumption-view-usage")}
      icon={carousel ? <AlertTriangle size={18} /> : <BarChart2 size={18} />}
      subtitle={""}
      content={
        <span
          dangerouslySetInnerHTML={{
            __html: translate(
              "dashboard-consumption-" + status + "-title",
            ) as string,
          }}
        />
      }
      body={
        <div>
          {status !== ConsumptionTrendEnum.New ? (
            <InsightsConsumptionTimeline data={data} />
          ) : null}
        </div>
      }
      type={type}
      onClick={() => {
        onActionClick("CLICK_INSIGHT_CONSUMPTION", "DASHBOARD");
        navigate(ROUTES.INSIGHTS);
      }}
    />
  );
}
